import React from "react";
import logo from "pages/parts/logo.png";
import { useHistory } from "react-router-dom";
import { Paths } from "Paths";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import "common.css";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        icon: {
            marginBottom: theme.spacing(1),
        },
        title: {
            marginLeft: theme.spacing(3),
            fontSize: `20px`,
        },
    })
);

export const Header: React.FC = () => {
    const classes = useStyles();
    const history = useHistory();

    return (
        <div className={`${classes.icon} cursorHand noPrint`}>
            <img src={logo} alt="" onClick={() => history.push(Paths.top)} />
            <span className={classes.title}>環境安全センター 廃液回収オンライン予約</span>
        </div>
    );
};
